import { createNS } from "@ontologies/core";

const solidActions = createNS("http://www.w3.org/ns/solid/actions/");

export default {
  ns: solidActions,
};
